import { render, staticRenderFns } from "./inventariosCRUD.vue?vue&type=template&id=2bdd5bf9"
import script from "./inventariosCRUD.vue?vue&type=script&lang=js"
export * from "./inventariosCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports